module.exports = __webpack_public_path__ + "static/media/MrAlexHo.dd8c9b6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/MrAlexHo.jpg
// module id = 205
// module chunks = 0